/**
 * GTM dataLayer bridge — surfaces agent milestones to the HOST page's
 * existing Google Tag Manager so the customer's own analytics/ads
 * stack can fire triggers on ShowPilot outcomes (their on-page GTM
 * can't see inside the widget otherwise).
 *
 * Contract (documented in Help/google-tag-manager.md — versioned,
 * never break):
 *   showpilot_agent_shown           { agent }   — impression denominator
 *   showpilot_conversation_started  { agent }
 *   showpilot_content_viewed        { title, type, url, source: 'agent'|'visitor' }
 *   showpilot_content_completed     { title, type }
 *   showpilot_voice_call_started    { }
 *   showpilot_lead_captured         { }         — NEVER carries PII
 *   showpilot_meeting_booked        { provider }
 *
 * We push to window.dataLayer directly (creating the array if absent —
 * the standard GTM pattern; harmless no-op on pages without GTM). We
 * NEVER load a GTM container on the host page: theirs is already
 * there, and a second container would duplicate tags + break consent.
 */
export function pushMilestone(event: string, data: Record<string, unknown>): void {
  try {
    const w = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
    (w.dataLayer = w.dataLayer || []).push({ event: `showpilot_${event}`, showpilot: data });
  } catch {
    // Never let analytics touch the host page's stability.
  }
  // The page SDK (main bundle) hears the same milestones under the webhook
  // vocabulary. Reached through the global, not an import, so the lazy
  // chunks that push milestones do not carry the SDK's code.
  try {
    window.showpilot?._emit?.(event, data);
  } catch {
    // A host handler's failure is not ours.
  }
}
